interface KpiCardProps {
  label: string;
  value: number;
  /** % change vs yesterday; null when there is no baseline to compare. */
  change: number | null;
  prefix?: string;
  isCurrency?: boolean;
}

export default function KpiCard({ label, value, change, prefix = '', isCurrency = true }: KpiCardProps) {
  const isPositive = (change ?? 0) >= 0;
  const formattedValue = isCurrency
    ? `₹${value.toLocaleString('en-IN')}`
    : `${prefix}${value.toLocaleString('en-IN')}`;

  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5 hover:border-background-300 transition-colors">
      <p className="text-xs md:text-sm text-foreground-500 mb-1">{label}</p>
      <div className="flex items-baseline gap-2">
        <span className="text-xl md:text-2xl font-bold text-foreground-800">{formattedValue}</span>
        {change === null ? (
          <span className="text-xs font-medium text-foreground-400">—</span>
        ) : (
          <span className={`text-xs font-medium flex items-center gap-0.5 ${isPositive ? 'text-secondary-500' : 'text-accent-500'}`}>
            <div className="w-3 h-3 flex items-center justify-center">
              <i className={`${isPositive ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-xs`}></i>
            </div>
            {Math.abs(change)}%
          </span>
        )}
      </div>
    </div>
  );
}
